import {createNewCompany, findInviterList, registerUserByUserInfo} from "../../../apiCall/signup/index.js";
import {ENCRYPT, ERROR_CODE} from "../constant.js";
import {isElectron} from "../../../util/electron/comm.js";
import {mobileSignIn, sendMoveMobileSignInPage} from "../../../bridge/renewal-signup/index.js";
import {getUser, isWebView} from "../store.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";

export class User {
    #_userId = "";
    #_email = "";
    #_userName = "";
    #_isGuest = false;
    #_password = "";
    #_jobType = "";
    #_marketingYn = "";
    #_companyName = "";
    #_companyCategory = "";
    #_companySubDomain = "";
    #_joinUseInttId = "";
    #_idGb = ""; //  NORMAL: "1",  KAKAO: "2",   GOOGLE: "3", APPLE: "11",
    #_profilePhoto = "";
    #_deviceNm = "";
    #_planId = "";
    #_hopeCount = "";
    #_phoneNumber = "";
    #_phoneAuthCompleted = false;
    #_authHash = "";
    #_serviceType = "";

    constructor(isGuest) {
        this.#_isGuest = isGuest;
        this.#_idGb = "1";
    }

    setUserId(userId) {
        this.#_userId = userId;
    }

    setEmail(email) {
        this.#_email = email;
    }

    getEmail() {
        return this.#_email;
    }

    getUserId() {
        return this.#_userId;
    }

    setUserName(userName) {
        this.#_userName = userName;
    }

    getUserName() {
        return this.#_userName;
    }

    setPassword(password) {
        this.#_password = password;
    }

    setJobType(jobType) {
        this.#_jobType = jobType;
    }

    setMarketingYn(marketingYn) {
        this.#_marketingYn = marketingYn;
    }

    setAsGuestUser(isGuest = false) {
        this.#_isGuest = isGuest
    }

    isGuestUser() {
        return this.#_isGuest;
    }

    setCompanyName(companyName) {
        this.#_companyName = companyName;
    }

    setCompanyCategory(companyCategory) {
        this.#_companyCategory = companyCategory;
    }

    setCompanySubDomain(subDomain) {
        this.#_companySubDomain = subDomain;
    }

    setJoinUseInttId(joinUseInttId) {
        this.#_joinUseInttId = joinUseInttId;
    }

    setIdGb(idGB) {
        this.#_idGb = idGB;
    }

    isSnsSignUp() {
        return this.#_idGb !== "1";
    }

    setProfilePhoto(profilePhoto) {
        this.#_profilePhoto = profilePhoto;
    }

    setDeviceName(deviceNm) {
        this.#_deviceNm = deviceNm;
    }

    getJoinUseInttId() {
        return this.#_joinUseInttId;
    }

    setPlanId(planId) {
        this.#_planId = planId;
    }

    getPlanId() {
        return Mutil.n2v(this.#_planId);
    }
    setHopeCount(hopeCount) {
        this.#_hopeCount = hopeCount;
    }
    setServiceType(serviceType) {
        this.#_serviceType = serviceType;
    }

    getPhoneNumber() {
        return Mutil.n2v(this.#_phoneNumber)
    }

    setPhoneNumber(phoneNumber) {
        this.#_phoneNumber = phoneNumber
    }

    getPhoneAuthCompleted() {
        return this.#_phoneAuthCompleted
    }

    setPhoneAuthCompleted(state) {
        this.#_phoneAuthCompleted = Mutil.n2v(state, false)
    }

    getAuthHash() {
        return this.#_authHash
    }

    setAuthHash(authHash) {
        this.#_authHash = Mutil.n2v(authHash, '')
    }

    async getInviterList() {
        const email = this.getEmail();
        if (Mutil.empty(email)) {
            Mutil.mlog("이메일 정보가 없어서 초대자 정보를 그릴 수 없습니다.");
            return [];
        }
        const data = await findInviterList(email);
        const inviterList = data.INVIT_REC;
        if (Mutil.empty(inviterList)) {
            Mutil.mlog("초대자 정보가 없습니다.");
            return [];
        }
        return inviterList;
    }

    async createNewCompany() {
        const linkedServiceJson = () => {
            if (Mutil.empty(window.connectInfo)) {
                return {};
            }
            try {
                const externalToken = JSON.parse(window.connectInfo.tokenInfo);
                Mutil.setCookie("ecommerceDomain","", 0);
                Mutil.setCookie("ecommerceClientId", "" , 0, 0);
                return {
                    LINKED_SERVICE_REC: [{
                        "ACCESS_TOKEN": externalToken.accessToken,
                        "REFRESH_TOKEN": externalToken.refreshToken,
                        "LINKED_TYPE": externalToken.linkedType,
                        "TOKEN_TYPE": externalToken.tokenType,
                        "EXPIRES_IN": externalToken.expiresIn,
                        "SERVICE_ID": window.connectInfo.clientId,
                        "DOMAIN": window.connectInfo.domain,
                    }]
                }
            } catch (e) {
                Mutil.mlog("linkedServiceJson error")
                return {};
            }
        }

        const CommonJoin = Mutil.requireIIFE("CommonJoin");
        const data = await createNewCompany({
            ...this.getCreateNewCompanyInfoJson(),
            ...CommonJoin?.getPartnerInfo(),
            ...linkedServiceJson(),
        });
        data.PASS_JSON = this.getSignInJson();
        data.PASS_JSON.DESKTOP_GUIDE_YN = 'N';
        data.COMPANY_INFO_JSON = {...this.getCreateNewCompanyInfoJson()};
        return data;
    }

    getSignInJson() {
        return {
            "ID_GB": this.#_idGb,
            "ENCRYPT_YN": ENCRYPT.SERVER_TIME_CHECK,
            "OBJ_CNTS_NM": (isElectron() ? "desktop" : ""),
            "DESKTOP_GUIDE_YN": "Y",
            "SUB_DOM": Mutil.n2v(this.#_companySubDomain),
            ...this.geUserProfileInfo()
        }
    }

    async joinCompanyBySubDom() {
        const data = await registerUserByUserInfo({
            ...this.getJoinCompanyInfo(),
        });
        data.PASS_JSON = this.getSignInJson();
        return data;
    }

    async registerGuest() {
        const data = await registerUserByUserInfo({
            ...this.geUserProfileInfo()
        });
        data.PASS_JSON = this.getSignInJson();
        return data;
    }

    registerGuestBySnS() {
        if (!this.isSnsSignUp()) {
            return;
        }
        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin(this.getRegisterGuestBySnsJson());
    }

    signInWithTwoFactor(data) {
        const {
            PASS_JSON = {}
        } = data;
        const moveMainPage = (PASS_JSON = {}, {firstLoginYn, desktopGuideYn}) => {
            if (isWebView()) {
                mobileSignIn(PASS_JSON);
                return;
            }

            const CommonLogin = Mutil.requireIIFE("CommonLogin");
            CommonLogin.moveMainPage({firstLoginYn, desktopGuideYn})
        }

        const moveSignInPage = () => {
            if (isWebView()) {
                sendMoveMobileSignInPage();
                return;
            }

            SignUpViewChanger.moveSignInPage();
        }

        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin({...PASS_JSON}, (isRequireTwoFactor = false, {firstLoginYn, desktopGuideYn}) => {
            if (!isRequireTwoFactor) {
                moveMainPage(PASS_JSON, {firstLoginYn, desktopGuideYn});
                return;
            }

            moveSignInPage();
        });
    }

    getRegisterGuestBySnsJson() {
        return {
            "USER_ID": this.#_userId,
            "ID_GB": this.#_idGb,
            "OBJ_CNTS_NM": Mutil.n2v(this.#_deviceNm),
            "EMAIL": Mutil.n2v(this.#_email),
            "USER_NM": Mutil.n2v(this.#_userName),
            "PRFL_PHTG": Mutil.n2v(this.#_profilePhoto),
            "MARKETING_YN": this.#_marketingYn,
            "RSPT_NM": this.#_jobType,
        }
    }

    getCreateNewCompanyInfoJson() {
        return {
            ...this.geUserProfileInfo(),
            "ID_GB": this.#_idGb,
            "SUB_DOM": this.#_companySubDomain,
            "SUB_DOM_NM": this.#_companyName,
            "PATH_CD": this.#_companyCategory,
            "PLAN_ID": this.#_planId,
            "HOPE_USER_COUNT": this.#_hopeCount,
            "DUPLICATE_SUB_DOM_YN": 'N',
            "TYPE": this.#_serviceType,
        };
    }


    getJoinCompanyInfo() {
        if (this.isSnsSignUp()) {
            return {
                "USER_NM": this.#_userName,
                "USER_ID": this.#_userId,
                "ID_GB": this.#_idGb,
                "MARKETING_YN": this.#_marketingYn,
                "SUB_DOM": this.#_companySubDomain,
                "AUTH_HASH": this.#_authHash,
            }
        }
        return {
            ...this.geUserProfileInfo(),
            "SUB_DOM": this.#_companySubDomain
        }
    }

    geUserProfileInfo() {
        return {
            "USER_NM": this.#_userName,
            "USER_ID": this.#_userId,
            "EMAIL": Mutil.n2v(this.#_email),
            "PRFL_PHTG": Mutil.n2v(this.#_profilePhoto),
            "PWD": this.#_password,
            "ID_GB": this.#_idGb,
            "MARKETING_YN": this.#_marketingYn,
            "RSPT_NM": this.#_jobType,
            "CLPH_NO": this.#_phoneNumber,
            "AUTH_HASH": this.#_authHash,
        }
    }


    toString() {
        //@todo 개발 끝나면 삭제
        return `
         유저 아이디 : ${this.#_userId} 
         이메일 : ${this.#_email}  
         유저 이름 : ${this.#_userName}
         타입 : ${this.#_isGuest ? "게스트" : "비즈니스"}
         비밀번호 : ${this.#_password}
         직책 : ${this.#_jobType}
         마케팅 동의 여부 : ${this.#_marketingYn}
         회사 이름 : ${this.#_companyName}
         회사 업종 : ${this.#_companyCategory}
         서브도메인 : ${this.#_companySubDomain} 
         프로필 이미지 : ${this.#_profilePhoto}
         아이디 구분 값  : ${this.#_idGb}
         플랜 아이디  : ${this.#_planId}
        `
    }
}